export const DO_SEND_PIN = '$$DO_SEND_PIN';
export const DO_SEND_PIN_SUCCESS = '$$DO_SEND_PIN_SUCCESS';
export const DO_SEND_PIN_FAIL = '$$DO_SEND_PIN_FAIL';

export const DO_SUBMIT_PIN = '$$DO_SUBMIT_PIN';
export const DO_SUBMIT_PIN_SUCCESS = '$$DO_SUBMIT_PIN_SUCCESS';
export const DO_SUBMIT_PIN_FAIL = '$$DO_SUBMIT_PIN_FAIL';

export const doSendPin = (data) => {
  return { type: DO_SEND_PIN, data }
}

export const doSubmitPin = (data) => {
  return { type: DO_SUBMIT_PIN, data }
}

export const sendPinSuccess = (e) => {
  return { type: DO_SEND_PIN_SUCCESS, e }
}

export const submitPinSuccess = (e) => {
  return { type: DO_SUBMIT_PIN_SUCCESS, e }
}
